import { NoAccessPage, type Me } from '@pa/staff'

/** "You don't have access to this site.": a super admin without an impersonation also gets the admin site (D-40). */
export function NoAccess({
  me,
  adminOrigin,
  impersonationEnded = false,
}: {
  me: Me
  adminOrigin: string
  impersonationEnded?: boolean
}) {
  return (
    <NoAccessPage
      siteName="PF Appointments"
      adminSiteUrl={me.platformRole === 'super_admin' || impersonationEnded ? `${adminOrigin}/` : undefined}
      impersonationEnded={impersonationEnded}
    />
  )
}
